import { render, staticRenderFns } from "./Szjc.vue?vue&type=template&id=13959f36&scoped=true&"
import script from "./Szjc.vue?vue&type=script&lang=js&"
export * from "./Szjc.vue?vue&type=script&lang=js&"
import style0 from "./Szjc.vue?vue&type=style&index=0&id=13959f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13959f36",
  null
  
)

export default component.exports